import { render, staticRenderFns } from "./TagsSelector.vue?vue&type=template&id=acc2648a&scoped=true&"
import script from "./TagsSelector.vue?vue&type=script&lang=js&"
export * from "./TagsSelector.vue?vue&type=script&lang=js&"
import style0 from "./TagsSelector.vue?vue&type=style&index=0&id=acc2648a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc2648a",
  null
  
)

export default component.exports